import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const TransactionTypeContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`

export const DatesContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`
